import { mapGetters }           from "vuex"
import { siteSectionsHelper }   from "@/components/mixins/siteSectionsHelper"
import { partSearch }           from "@/components/mixins/partSearch.ts"
import DnFunctionButton         from "@/components/Elements/DnFunctionButton.vue"
import { ErrorLogService }      from "@/services"
import { ExclusionTypeIds }     from "@/types";
import { azureDevopsInfoMixin } from "@/components/mixins/azureDevopsInfoMixin"
import { FeatureFlagService } from "@/services/FeatureFlagService"
import { constants } from "@/const"


export default {
    components: {
        DnFunctionButton
    },
    mixins: [siteSectionsHelper, partSearch, azureDevopsInfoMixin],
    props: {
        shouldShowSearchControls: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        partNumber: "",
        showModal: false,
        isSearching: false
    }),
    computed: {
        ...mapGetters([
            "getContentItem", 
            "user", 
            "IsMcfa", 
            "IsMcfs",
            "manualsUrl",
            "activeAccountId",
            "audienceAndExclusions",
            "audienceIds"
        ]),
        showTms(){
            
            var exclusions = this.audienceAndExclusions.Exclusions;
            var crossSearchExclusions = exclusions.filter(x => 
                x.ExclusionType == ExclusionTypeIds.CrossSearch &&
                this.audienceIds.includes(x.Audience.Id)
            );
            if(crossSearchExclusions && crossSearchExclusions.length > 0)
            {
                return false;
            }
            return true;
        },
            showDiagramsButton(){
                return FeatureFlagService.getFeatureEnabled(constants.FEATURE_NAMES.SHOW_DIAGRAMS_BUTTON);
            },
    },
    methods: {
        async SearchForPart() {
            this.partNumber = this.partNumber.trim();

            if (!this.partNumber){
                return;
            }
            
            try {
                this.isSearching = true;
                let pageNumber = 1;
                let isQuerySearch = false;
                await this.searchParts(pageNumber, pageNumber, this.partNumber, isQuerySearch);
            } catch (err) {
                ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.isSearching = false
                this.partNumber = "";
            }
        }
    }
}